module.exports = __webpack_public_path__ + "img/icon-sb-low-alert-orange-48x48.b6e80ec.svg";